export default {
  title: {
    id: 'bo_sellers_customer_care_request_details_customer_title',
    defaultMessage: 'Customer: {firstName} {lastName}',
  },
  description: {
    id: 'bo_sellers_customer_care_request_details_customer_description',
    defaultMessage: 'Shipping and billing addresses',
  },
  billingAddress: {
    id: 'sav_platform_billing_address',
    defaultMessage: 'Billing address',
  },
  shippingAddress: {
    id: 'sav_platform_delivery_address',
    defaultMessage: 'Shipping address',
  },
  errorDescription: {
    id: 'bo_sellers_customer_care_request_details_customer_description_error',
    defaultMessage: 'Couldn’t load customer details',
  },
}
